import { render, staticRenderFns } from "./informationReport.vue?vue&type=template&id=b461d260&scoped=true&"
import script from "./informationReport.vue?vue&type=script&lang=js&"
export * from "./informationReport.vue?vue&type=script&lang=js&"
import style0 from "./informationReport.vue?vue&type=style&index=0&id=b461d260&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b461d260",
  null
  
)

export default component.exports